import './ProjectBlock.scss'
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {connect} from "react-redux";
import {ArrIcon, BlogBlockArrIcon} from "../../../assets/images";
import BlogCard from "../../uiElements/cards/blogCard/BlogCard";
import {Link} from "react-router-dom";


function ProjectBlock(props) {
    const {project,staticTexts} = props

    return <div className={'projectBlock-wrapper'}>
        {
            project?.length ? <Link to={'/project'} className={'projectBlock-header'}>
                <div className={'projectBlock-title'}>
                    {staticTexts?.homepage_project_title}
                </div>
                <div className={'projectBlock-more'}>
                    <BlogBlockArrIcon/>
                </div>
            </Link> : ''
        }
        <div className={'projectBlock'}>
            {
                project?.map(item => {
                    return <div className={'projectBlock-card'}>
                        <BlogCard item={item}/>
                    </div>
                })
            }
        </div>
    </div>

}const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
        'project',
    ])
};
const mapDispatchToProps = {
};
export default connect(mapStateToProps,mapDispatchToProps)(ProjectBlock);